import api from '../index'

export interface Admin {
  id: number
  username: string
  name: string
  phone: string
  email?: string
  gender?: 0 | 1 | 2
  employment_status?: 1 | 2
  avatar?: string
  last_login_at?: string
  last_login_ip?: string
  remark?: string
  created_at: string
  updated_at: string
  roles?: any[]
}

export interface SystemAdmin extends Admin {}

export interface AdminListParams {
  page?: number
  per_page?: number
  keyword?: string
}

export interface AdminCreateData {
  username: string
  name: string
  phone: string
  password: string
  password_confirmation: string
  email?: string
  gender?: 0 | 1 | 2
  employment_status?: 1 | 2
  avatar?: string
  remark?: string
}

export interface AdminUpdateData {
  username?: string
  name?: string
  phone?: string
  email?: string
  gender?: 0 | 1 | 2
  employment_status?: 1 | 2
  avatar?: string
  remark?: string
}

export const adminApi = {
  // 获取管理员列表
  list: (params?: AdminListParams) => api.get('system-admin/list', { params }),

  // 获取所有管理员列表（用于权限分配）
  getList: (params?: AdminListParams) => api.get('system-admin/list', { params }),

  // 获取活跃管理员列表
  activeList: (params?: AdminListParams) => api.get('system-admin/active-list', { params }),

  // 获取管理员详情
  detail: (id: number) => api.get(`system-admin/${id}`),

  // 创建管理员
  create: (data: AdminCreateData) => api.post('system-admin', data),

  // 更新管理员
  update: (id: number, data: AdminUpdateData) => api.put(`system-admin/${id}`, data),

  // 删除管理员
  delete: (id: number) => api.delete(`system-admin/${id}`),

  // 更新在职状态
  updateEmploymentStatus: (id: number, status: 1 | 2) => api.put(`system-admin/${id}/employment-status`, { employment_status: status }),

  // 重置密码
  resetPassword: (id: number, password: string) => api.put(`system-admin/${id}/reset-password`, { password }),
}

export default adminApi
